import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import './index.css';
import { loadAppConfig } from 'config/appConfig';
import { setResolvedTenant } from 'config/resolvedTenant';
import { initI18n } from 'i18n';
import { setupInterceptors } from 'api/interceptors';
import tenantResolverService from 'services/tenantResolverService';
import TenantNotFound from 'components/feedback/TenantNotFound';
import { createStoreTheme } from 'theme';
import { applyCachedThemeToDocument, readCachedTheme } from 'utils/themeCache';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const bootstrap = async () => {
  const config = await loadAppConfig();
  initI18n(config.defaultLocale);

  const tenant = await tenantResolverService.resolve(config);
  if (!tenant) {
    root.render(
      <ThemeProvider theme={createStoreTheme('light')}>
        <CssBaseline />
        <TenantNotFound />
      </ThemeProvider>
    );
    return;
  }

  setResolvedTenant(tenant);
  applyCachedThemeToDocument(readCachedTheme());
  setupInterceptors();

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

bootstrap();
